import React, { useState, useRef } from 'react';
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import leafletImage from 'leaflet-image';

L.Marker.prototype.options.icon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
});

export function getLeafletColor(color) {
    switch (color) {
        case 'M&S':  return '#c8a800';
        case 'M':    return '#e53935';
        case 'S':    return '#1565c0';
        case 'ORRI': return '#77dd77';
        case 'All':  return '#00acc1';
        default:     return '#888888';
    }
}

export function extractKMLCoords(kml, minPoints = 1) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(kml, 'text/xml');

    const parserError = doc.querySelector('parsererror');
    if (parserError) throw new Error('Invalid KML: parsing failed');

    const nsResolver = (prefix) => (prefix === 'kml' ? 'http://www.opengis.net/kml/2.2' : null);

    const coordNode = doc.evaluate(
        '//kml:Placemark//kml:coordinates',
        doc,
        nsResolver,
        XPathResult.FIRST_ORDERED_NODE_TYPE,
        null
    ).singleNodeValue;

    if (!coordNode) throw new Error('No coordinates found');

    const pairs = coordNode.textContent
        .trim()
        .split(/\s+/)
        .map((s) => s.split(',').map(Number))
        .filter(([lng, lat]) => !isNaN(lng) && !isNaN(lat))
        .map(([lng, lat]) => [lat, lng]);

    if (pairs.length < minPoints) {
        throw new Error(`Need at least ${minPoints} coordinate point${minPoints !== 1 ? 's' : ''}`);
    }
    return pairs;
}

export function useMapScreenshot(mapInstance, filename = 'map-screenshot') {
    const [capturingMap, setCapturingMap] = useState(false);
    const mapRef = useRef(mapInstance);
    mapRef.current = mapInstance;
    const filenameRef = useRef(filename);
    filenameRef.current = filename;

    const takeScreenshot = () => {
        const map = mapRef.current;
        if (!map) return;
        setCapturingMap(true);
        leafletImage(map.leafletElement, (err, canvas) => {
            if (err) { setCapturingMap(false); return console.error('Screenshot failed:', err); }
            canvas.toBlob(blob => {
                const a = document.createElement('a');
                a.href = URL.createObjectURL(blob);
                a.download = `${filenameRef.current}.png`;
                a.click();
                URL.revokeObjectURL(a.href);
                setCapturingMap(false);
            });
        });
    };

    return { takeScreenshot, capturingMap };
}

export function MapCaptureOverlay({ visible }) {
    if (!visible) return null;
    return (
        <div style={{
            paddingLeft: 215,
            position: 'absolute',
            inset: 0,
            background: 'rgba(0,0,0,0.4)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            <span style={{ color: 'white', fontSize: '1.2rem', fontWeight: 'bold', letterSpacing: 1 }}>
                Processing… <CameraAltIcon style={{ fontSize: '1.2rem', color: 'white' }} />
            </span>
        </div>
    );
}

export function MapCameraButton({ onClick }) {
    return (
        <button
            type="button"
            onClick={onClick}
            title="Capture Map"
            style={{
                position: 'absolute',
                top: 70,
                right: 10,
                zIndex: 1000,
                width: 48,
                height: 48,
                background: '#fff',
                border: '2px solid rgba(0,0,0,0.2)',
                borderRadius: 4,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 0,
            }}
        >
            <CameraAltIcon style={{ fontSize: 28, color: 'black' }} />
        </button>
    );
}
